<ng-container *ngIf="itinerary$ | async as itinerary">
    <div
        class="max-h-[250px] transition-all duration-500 ease-in-out"
        [ngClass]="{
            'bg-[var(--color-primary)] dark:bg-contrast-black': this.env.THEME_NAME === 'gotland-v2',
            '!max-h-0': fullShowMap | async
        }">
        <rwidget-itinerary-details-header
            [itinerary]="itinerary"
            [currentTime]="currentTime$ | async"></rwidget-itinerary-details-header>
    </div>

    <rwidget-small-screen-sheet-modal-container
        *ngIf="!env.JOURNEY_PLANNER?.SHOW_FULL_MAP || (fullShowMap | async) === false"
        [rollUpOnMapClick]="true"
        [isFullHeightContainer]="env.IS_MOBILE_APP"
        [minimalBreakpointOffset]="modalBreakpointOffset">
        <div class="bg-white pb-3 pt-3 shadow-md">
            <rwidget-journey-itinerary
                [currentTime]="currentTime$ | async"
                [itinerary]="itinerary"
                [itineraryDetailsPage]="true"></rwidget-journey-itinerary>
            <rwidget-journey-price [itinerary]="itinerary"></rwidget-journey-price>
        </div>

        <div class="mt-0">
            <rwidget-itinerary-legs-overview
                [itinerary]="itinerary"
                [legs]="itinerary?.legs"
                [legTripIdToDetailsMap]="tripIdToDetailsMap"></rwidget-itinerary-legs-overview>
        </div>

        <div class="mx-4 mb-4 mt-3 print:hidden" *ngIf="env.JOURNEY_PLANNER?.BUTTONS?.length > 0">
            <button
                class="flex w-full items-center justify-center border-t border-solid border-[rgba(0,0,0,0.1)] py-3 text-[16px] font-semibold leading-5 text-secondary dark:text-contrast-yellow"
                *ngIf="env.JOURNEY_PLANNER?.BUTTONS?.includes('SHOW_PRINT_BUTTON')"
                (click)="printSchedule()">
                <ion-icon
                    class="mr-1 h-8 w-8 dark:filter-yellow"
                    aria-label="{{ 'PRINT_JOURNEY' | translate }}"
                    title="{{ 'PRINT_JOURNEY' | translate }}"
                    src="{{ assetsPath$ | async }}/img/journey-planner/print-icon.svg"></ion-icon>
                {{ 'PRINT_JOURNEY' | translate }}
            </button>
        </div>
    </rwidget-small-screen-sheet-modal-container>
</ng-container>
